import React from "react";

const STATUS_STYLES = {
  paid: "bg-emerald-500/15 text-emerald-300",
  pending: "bg-white/10 text-white/70",
  pending_payment: "bg-sfc-yellow/15 text-sfc-yellow",
  pending_business_verification: "bg-sfc-orange/15 text-sfc-orange",
  failed: "bg-red-500/15 text-red-300",
  expired: "bg-red-500/15 text-red-300",
  canceled: "bg-white/10 text-white/50",
  open: "bg-sfc-cyan/15 text-sfc-cyan",
  approved: "bg-emerald-500/15 text-emerald-300",
  approved_for_payment: "bg-emerald-500/15 text-emerald-300",
  manual_review_required: "bg-sfc-orange/15 text-sfc-orange",
  rejected: "bg-red-500/15 text-red-300",
  archived: "bg-white/10 text-white/40",
  logged: "bg-sfc-cyan/15 text-sfc-cyan",
  sent: "bg-emerald-500/15 text-emerald-300",
};

export function Badge({ status }) {
  const cls = STATUS_STYLES[status] || "bg-white/10 text-white/60";
  return <span className={`inline-block rounded-full px-2.5 py-1 text-xs font-medium ${cls}`}>{(status || "").replace(/_/g, " ")}</span>;
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
      <div>
        <h1 className="font-display text-3xl text-white">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-white/50">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function Card({ children, className = "" }) {
  return <div className={`rounded-2xl border border-white/10 bg-white/[0.03] ${className}`}>{children}</div>;
}

export function Th({ children }) {
  return <th className="whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-white/45">{children}</th>;
}
export function Td({ children, className = "" }) {
  return <td className={`whitespace-nowrap px-4 py-3 text-sm text-white/80 ${className}`}>{children}</td>;
}

export function Empty({ text = "Geen gegevens" }) {
  return <div className="py-16 text-center text-white/40">{text}</div>;
}

export function fmtDate(iso) {
  if (!iso) return "-";
  try { return new Date(iso).toLocaleString("nl-NL", { dateStyle: "short", timeStyle: "short" }); }
  catch { return iso; }
}
